import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"
import _imports_0 from '../../assets/zt_404.png'
import _imports_1 from '@/assets/img/tips／exclamation-circle-fill@2x.png'


const _hoisted_1 = {
  class: "purchasedCar comBox",
  style: {"margin-top":"0.7rem"}
}
const _hoisted_2 = { style: {"width":"100%","margin-bottom":"0.16rem"} }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = {
  style: {},
  class: "table_img"
}
const _hoisted_5 = {
  key: 0,
  class: "materialStatus"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "table_information" }
const _hoisted_8 = { style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","color":"#333333","font-size":"0.14rem"} }
const _hoisted_9 = {
  key: 0,
  style: {"color":"#86909c","font-size":"0.12rem"},
  class: "typeName"
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"#86909c","font-size":"0.12rem"},
  class: "typeName"
}
const _hoisted_11 = {
  key: 2,
  style: {"color":"#86909c","font-size":"0.12rem"},
  class: "typeName"
}
const _hoisted_12 = { style: {"font-size":"0.14rem"} }
const _hoisted_13 = { style: {"color":"#C01A26"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  style: {"height":"550px"}
}
const _hoisted_16 = { class: "table_bottom" }
const _hoisted_17 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_18 = { style: {"font-size":"0.14rem","color":"#333333","margin-left":"0.13rem"} }
const _hoisted_19 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_20 = { class: "yixuan" }
const _hoisted_21 = { style: {"color":"#C01A26"} }
const _hoisted_22 = { class: "heji" }
const _hoisted_23 = { style: {"color":"#C01A26"} }
const _hoisted_24 = { style: {"text-align":"center","font-size":"0.16rem","margin":"0.16rem 0"} }
const _hoisted_25 = { style: {"display":"flex","justify-content":"center"} }

import { ref } from "vue";
import type { TabsPaneContext } from "element-plus";
import { ElMessage, ElTable } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
interface User {
  date: string;
  name: string;
  name1: string;
  address: string;
  katype: string;
  price: string;
  number: number;
  time: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'purchasedCar',
  setup(__props) {

document.title = "标识山西-购物车";
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};
// 表格

const totalPay = ref(0.0);

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
  console.log(multipleTableRef.value);
  totalAmount();
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
  totalAmount();
  console.log(multipleSelection);
};
var data = ref([]); // 创建一个空数组
//全选
const allCheckbox = ref(false);
const selectAll = () => {
  allCheckbox.value = !allCheckbox.value;
  console.log(allCheckbox.value);
  if (allCheckbox.value) {
    data.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, true);
    });
    totalAmount();
  } else {
    data.value.forEach((item, index) => {
      console.log(multipleTableRef.value);
      multipleTableRef.value!.toggleRowSelection(item, false);
    });

    totalAmount();
  }
};
const totalAmount = () => {
  let sum = 0;
  multipleSelection.value.forEach((item) => {
    sum += item.newPayCount * item.selfPrice;
  });

  totalPay.value = sum.toFixed(2);
};
// 删除、批量删除
let title = ref("");
let dialogDelVisible = ref(false);
let delArry = ref([]); //删除id
const handleDel = (index, row) => {
  title.value = "确定删除此商品？";
  dialogDelVisible.value = true;
  delArry.value = [];
  delArry.value = [row.id];
};
const handleAllDel = (type) => {
  if (multipleSelection.value.length == 0) {
    ElMessage({
      message: "请勾选商品",
      type: "error",
    });
    return;
  }
  title.value = "确定批量删除勾选的商品？";
  dialogDelVisible.value = true;
  delArry.value = [];

  multipleSelection.value.forEach((item) => {
    delArry.value.push(item.id);
  });
};
//购物车失效商品清除
const handleAllExpire = (type) => {
  title.value = "确定清除全部失效商品？";

  delArry.value = [];
  data.value.forEach((item, index) => {
    if (item.materialStatus != 1) {
      delArry.value.push(item.id);
    }
  });

  if (delArry.value.length == 0) {
    ElMessage({
      message: "暂无失效商品",
      type: "error",
    });
    return;
  }

  dialogDelVisible.value = true;
};

//确认删除
const delSubmit = () => {
  Axios("delete", `/fodder/car/${delArry.value}`, {}, false, (res) => {
    if (res.data.code == 200) {
      dialogDelVisible.value = false;
      get_dindanList();

      ElMessage({
        message: "删除成功",
        type: "success",
      });
    } else {
      ElMessage({
        message: "删除错误",
        type: "error",
      });
    }
  });
};

/**表格回调函数*/
const callback = (row, index) => {
  return row.materialStatus == 1 ? 1 : 0;
};

//购物车列表展示
const get_dindanList = function () {
  Axios(
    "get",
    "/fodder/car/list",
    {
      memberId: JSON.parse(localStorage.getItem("userList")).memberId,
      orderByColumn: "a.create_time",
      isAsc: "DESC",
    },
    false,
    function (res) {
      res.data.rows.forEach((item, index) => {
        item.newPayCount = 1;
      });
      data.value = res.data.rows;
    }
  );
};
get_dindanList();

//结算
const router = useRouter();
const paymentClick = () => {
  // totalPay.value  勾选的总金额
  // multipleSelection.value   勾选购物车的商品
  if (multipleSelection.value.length == 0) {
    ElMessage({
      message: "请选择商品",
      type: "warning",
    });
    return;
  }
  let idArray = [];
  let isStop = false;
  multipleSelection.value.forEach((item, index) => {
    idArray.push(item.id);
    if(item.selfPrice == 0){
      isStop = true
    }
  });
  if (isStop) {
    ElMessage({
      message: "免费商品不可加入购物车,请删除",
      type: "warning",
    });
    return;
  }
  let query = idArray.join(",");

  Axios("get", "/fodder/car/index/" + query, false, false, function (res) {
    router.push({
      path: "/myOrderDetial",
      query: {
        type: "car",
        arry: query,
      },
    });
    // window.close();
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"color":"#333333","font-size":"0.2rem","margin-bottom":"0.2rem"} }, " 购物车 ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElTable), {
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          data: _unref(data),
          onSelectionChange: handleSelectionChange,
          style: {"width":"100%"},
          height: "550"
        }, {
          empty: _withCtx(() => [
            (_unref(data).length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { style: {"width":"90%","margin":"0 auto"} }, [
                    _createElementVNode("img", {
                      style: {"width":"100%","margin":"0 auto"},
                      src: _imports_0
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "55",
              selectable: callback
            }),
            _createVNode(_component_el_table_column, {
              property: "name",
              "min-width": "100",
              label: "全部素材"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (scope.row.materialStatus != 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 失效商品 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      style: {"width":"100%","height":"100%"},
                      src: scope.row.showImage
                    }, null, 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(scope.row.title), 1),
                    (scope.row.authType == 'SELF')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 个人授权 "))
                      : _createCommentVNode("", true),
                    (scope.row.authType == 'ENTERPRISE')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 企业授权 "))
                      : _createCommentVNode("", true),
                    (scope.row.authType == 'UNION')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 联盟授权 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"color":"#86909c"} }, "单价：", -1)),
                      _createTextVNode(_toDisplayString(scope.row.selfPrice), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              align: "center",
              property: "newPayCount",
              width: "200"
            }),
            _createVNode(_component_el_table_column, {
              label: "价格",
              align: "center",
              property: "price",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_13, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "￥", -1)),
                  _createTextVNode(_toDisplayString((scope.row.selfPrice * scope.row.newPayCount).toFixed(2)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "190",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"color":"#ff2929","cursor":"pointer"},
                  onClick: ($event: any) => (handleDel(scope.$index, scope.row, 'del'))
                }, " 删除 ", 8, _hoisted_14)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (!allCheckbox.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: selectAll,
                    class: "el-checkbox__inner_zd"
                  }))
                : _createCommentVNode("", true),
              (allCheckbox.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    onClick: selectAll,
                    class: "el-checkbox__inner_select"
                  }))
                : _createCommentVNode("", true),
              _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"margin-top":"-10px","margin-left":"5px","color":"#666"} }, "全选", -1))
            ]),
            _createElementVNode("div", {
              style: {"color":"#86909c","margin-left":"0.32rem","font-size":"0.14rem","cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAllDel('delAll')))
            }, " 删除选中商品 "),
            _createElementVNode("div", {
              style: {"color":"#86909c","margin-left":"0.32rem","font-size":"0.14rem","cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAllExpire('expire')))
            }, " 清除失效商品 ")
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[8] || (_cache[8] = _createTextVNode(" 已选商品")),
              _createElementVNode("span", _hoisted_21, _toDisplayString(multipleSelection.value.length), 1),
              _cache[9] || (_cache[9] = _createTextVNode("件 "))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[10] || (_cache[10] = _createTextVNode(" 合计： ")),
              _createElementVNode("span", _hoisted_23, "￥" + _toDisplayString((totalPay.value / 1).toFixed(2)), 1)
            ]),
            _createElementVNode("div", {
              class: "btn",
              onClick: paymentClick
            }, "结算")
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: _unref(dialogDelVisible),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogDelVisible) ? (dialogDelVisible).value = $event : dialogDelVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"width":"0.4rem","height":"0.4rem","margin":"0 auto"} }, [
          _createElementVNode("img", {
            style: {"height":"100%"},
            src: _imports_1
          })
        ], -1)),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(title)), 1),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "dataBtnClose",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogDelVisible) //@ts-ignore
 ? dialogDelVisible.value = false : dialogDelVisible = false))
          }, "取消"),
          _createElementVNode("div", {
            class: "dataBtnSubmit",
            onClick: delSubmit
          }, "确认")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})